import { useEffect, useState } from "react";

import { useGetInfluencerStore } from "@entities/discovery/lib/store/useGetInfluencerStore";
import { Modal, Row } from "@shared/ui";

import { PlusOutlined } from "@ant-design/icons";
import { useAddCreatorsToBuckets } from "@entities/bucket/lib/hooks/useAddCreatorsToBuckets";
import CampaignReachoutInfluencerModal from "@entities/campaign-reach-out/ui/CampaignReachoutModal";
import { useAddSocialMedia } from "@entities/discovery/lib/hooks/useAddSocialMedia";
import { SocialMediaForm } from "@entities/influencer/ui/SocialMedia/SocialMediaForm";
import { ToastService } from "@shared/lib/services";
import { AddBy, ICreator } from "@shared/lib/types";
import { Button } from "@shared/ui/Button";
import { InfluencerTable } from "@shared/ui/InfluencerTable/InfluencerTable";
import AddToBucket from "@shared/ui/Modals/AddToBucket";
import { Divider, Space, Spin } from "antd";

export function DiscoveryPage() {
  const [socialMediaModalVisible, setSocialMediaVisible] = useState(false);
  const { isLinking, addSocialMedia, isLinked } = useAddSocialMedia();
  const [selectedCreators, setSelectedCreators] = useState<ICreator[]>([]);
  const [isBucketModalVisible, setBucketModalVissible] =
    useState<boolean>(false);
  const { facets } = useGetInfluencerStore();
  const { addToBucket, isAdding, isAdded } = useAddCreatorsToBuckets();
  const [bucketIds, setselectedbuckedIds] = useState<string[]>([]);
  const [isCampaignReachOutModalVisible, setCampaignReachOutModalVisible] =
    useState<boolean>(false);

  const ButtonComponent = () => {
    return (
      <Row style={{ gap: 5 }}>
        {selectedCreators.length > 0 && (
          <Button
            onClick={() => {
              selectedCreators?.forEach((influencer) => {
                if (influencer?.link) {
                  window.open(influencer?.link || "", "_blank");
                }
              });
            }}
          >
            Open Profile Links
          </Button>
        )}
        {selectedCreators.length > 0 && (
          <Button onClick={() => setBucketModalVissible(true)}>
            Add to bucket
          </Button>
        )}
        {selectedCreators.length > 0 && (
          <Button onClick={() => setCampaignReachOutModalVisible(true)}>
            Campaign Reach Out
          </Button>
        )}
      </Row>
    );
  };
  useEffect(() => {
    if (isLinked) {
      setSocialMediaVisible(false);
    }
  }, [isLinked]);
  const handleAdd = (bucketIds: string[]) => {
    const addBy: AddBy[] = selectedCreators.map((creator) => {
      return creator?.socialMediaObjectId
        ? {
            socialMediaObjectId: creator.socialMediaObjectId,
          }
        : {
            socialMediaHandle: {
              platform: creator?.platform,
              username: creator?.username,
              link: creator?.link,
            },
          };
    });
    addToBucket({ bucketIds, addBy });
  };
  useEffect(() => {
    if (isAdded) {
      setBucketModalVissible(false);
      setSelectedCreators([]);
      ToastService.success("Influencers added to bucketets");
    }
  }, [isAdded]);
  return (
    <div>
      <InfluencerTable
        isLinked={isLinked}
        ButtonComponent={ButtonComponent}
        selectedCreators={selectedCreators}
        setSelectedCreators={setSelectedCreators}
        TopEditButton={() => <Button
          type="primary"
          onClick={() => setSocialMediaVisible(true)}
          icon={<PlusOutlined />}
        >
          Add Social Media
        </Button>}
      />
      <Modal
        title="Add Social Media"
        open={socialMediaModalVisible}
        onCancel={() => setSocialMediaVisible(false)}
        footer={null}
        destroyOnClose
        width={700}
      >
        <SocialMediaForm
          handleAdd={(socialMedia) => addSocialMedia({ socialMedia })}
          isAdding={isLinking}
          socialMediasToDisplay={(facets["platforms"] || [])?.map(
            (item) => item._id
          )}
        />
      </Modal>
      <Modal
        title="Add Influencer To Bucket"
        open={isBucketModalVisible}
        onCancel={() => setBucketModalVissible(false)}
        footer={
          <>
            <Divider style={{ margin: "8px 0" }} />
            <Space
              style={{
                padding: "0 8px 4px",
                width: "100%",
                justifyContent: "space-between",
              }}
            ></Space>
            {bucketIds.length > 0 && (
              <Row style={{ justifyContent: "center", padding: 10 }}>
                {isAdding ? (
                  <Spin style={{ width: 30, height: 30 }} />
                ) : (
                  <Button
                    onClick={async () => handleAdd(bucketIds)}
                    icon={<PlusOutlined />}
                  >
                    Add to selected buckets
                  </Button>
                )}
              </Row>
            )}
          </>
        }
        destroyOnClose
      >
        <AddToBucket
          bucketIds={bucketIds}
          setselectedbuckedIds={setselectedbuckedIds}
          mode="multiple"
        />
      </Modal>

      <CampaignReachoutInfluencerModal
        visible={isCampaignReachOutModalVisible}
        onClose={() => setCampaignReachOutModalVisible(false)}
        userData={selectedCreators?.map((ele) => ({
          name: ele.name,
          platform: ele.platform,
          username: ele.username,
          profilePicUrl: ele.profilePicUrl,
          link: ele.link,
        }))}
      />
    </div>
  );
}
